module.exports = "/_next/static/images/ca-f8c2d1128e2e35a38fff9f40886bec5c.svg";